import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { generateAddedValueFormName } from '../../../helpers/form-added-value-name-generator';

@Injectable()
export class ResetValueAddedCommand implements OnFieldChanged {
  onFieldChanged(value: any, form: UntypedFormGroup): void {
    const firstAddedValueControl = form.get(generateAddedValueFormName(0));
    if (firstAddedValueControl.value) {
      firstAddedValueControl.setValue(undefined);
    }

    const firstAddedValueControl1 = form.get(generateAddedValueFormName(1));
    if (firstAddedValueControl1.value) {
      firstAddedValueControl1.setValue(undefined);
    }

    const firstAddedValueControl2 = form.get(generateAddedValueFormName(2));
    if (firstAddedValueControl2.value) {
      firstAddedValueControl2.setValue(undefined);
    }

    const firstAddedValueControl3 = form.get(generateAddedValueFormName(3));
    if (firstAddedValueControl3.value) {
      firstAddedValueControl3.setValue(undefined);
    }
  }
}
